import React from 'react'
import Link from 'gatsby-link'
import Galleries from '../components/galleries/galleries.js'
import Layout from '../layouts/index.js'

const Gallery = () => (
  <Layout>
    <section>
      <h1>Gallery</h1>
      <article>
        <p>
          Here is a small selection of photographs taken by Sue Flood during her
          travels. You, too, can explore these destinations, as part of an
          organised expedition or on a tailor made private tour. See{' '}
          <Link to="/trips-events">Trips & Events</Link>. Many of these images,
          and more, are available for editorial/commercial use. Please see the{' '}
          <Link to="/stock-photography">Stock Photography</Link> section.
        </p>
      </article>
      <Galleries />
    </section>
  </Layout>
)

export default Gallery
